import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionReservationAdditionalFee } from "./additional-fee";

import type { HotelPolicyI18nCategoriesAndManagerStore } from "../../../store/categories";

type Props = {
	reservationAdditionalFeeSettings: HotelPolicyI18nCategoriesAndManagerStore["reservationAdditionalFeeSettings"];
};

export const QuestionReservationAdditionalFeeSettings = ({ reservationAdditionalFeeSettings }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={reservationAdditionalFeeSettings}>
			<QuestionReservationAdditionalFee />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionReservationAdditionalFeeSettings.displayName = "QuestionReservationAdditionalFeeSettings";
